import { legalDocuments, type LegalDocumentKey } from '../data/legalDocuments';
import { useI18n } from '../i18n/useI18n';
import { useSeo } from './useSeo';

type LegalDocumentPageProps = {
  documentKey: LegalDocumentKey;
  titleKey: string;
  descriptionKey: string;
};

export function LegalDocumentPage({
  documentKey,
  titleKey,
  descriptionKey,
}: LegalDocumentPageProps) {
  const { language, t } = useI18n();
  const document = legalDocuments[documentKey][language];
  useSeo(titleKey, descriptionKey);

  return (
    <main>
      <section className="page-hero legal-hero">
        <p className="eyebrow">{document.eyebrow}</p>
        <h1>{document.title}</h1>
        <p>{document.intro}</p>
        <p className="legal-updated">
          {t('legal.updated', { date: document.updated })}
        </p>
      </section>
      <section className="section legal-document" aria-label={document.title}>
        {document.sections.map((section) => (
          <article className="legal-section" key={section.title}>
            <h2>{section.title}</h2>
            {section.body?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            {section.items ? (
              <ul>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
          </article>
        ))}
      </section>
    </main>
  );
}
